import React from 'react';
import type { HSAlign } from '@types';
import Tabbar from '../../Tabbar';
import WidgetRow from '../WidgetRow';
import {
  IconCenter,
  IconCenterV,
  IconLeft,
  IconLeftV,
  IconRight,
  IconRightV,
  IconJustify,
} from './icons';

interface Props {
  value: HSAlign;
  vertical?: boolean;
  hasJustify?: boolean;
  onChange: (align: HSAlign) => void;
}

function WidgetRowAlign({
  value,
  vertical = false,
  hasJustify = false,
  onChange,
}: Props) {
  const values: HSAlign[] = hasJustify
    ? ['left', 'center', 'right', 'justify']
    : ['left', 'center', 'right'];

  const getIndex = (align: HSAlign) =>
    values.findIndex((x) => x === align) ?? 0;

  const hTabs = hasJustify
    ? [
        <IconLeft active={value === 'left'} />,
        <IconCenter active={value === 'center'} />,
        <IconRight active={value === 'right'} />,
        <IconJustify active={value === 'justify'} />,
      ]
    : [
        <IconLeft active={value === 'left'} />,
        <IconCenter active={value === 'center'} />,
        <IconRight active={value === 'right'} />,
      ];
  const tabs = vertical
    ? [
        <IconLeftV active={value === 'left'} />,
        <IconCenterV active={value === 'center'} />,
        <IconRightV active={value === 'right'} />,
      ]
    : hTabs;

  const hTips = hasJustify
    ? ['左对齐', '居中对齐', '右对齐', '两端对齐']
    : ['左对齐', '居中对齐', '右对齐'];
  const tips = vertical ? ['上对齐', '居中对齐', '下对齐'] : hTips;

  return (
    <WidgetRow>
      <div className="mb-10">对齐方式：</div>
      <Tabbar
        tabs={tabs}
        tips={tips}
        activeIndex={getIndex(value)}
        onChange={(index) => onChange(values[index])}
      />
    </WidgetRow>
  );
}

export default WidgetRowAlign;
